'use strict';
/* globals $ */

// Organize the list of collections
$(document).ready(function() {

	if ($('body').hasClass('template-list-collections')) {
		var collections = $('#collection-list li');
		$('#collection-list').empty();

		collectionsLoop:
		for (var i = 0; i < collections.length; i++) {

			// Collection
			var firstCollection = collections.eq(i);

			// Get the first letter
			var headingLetter = firstCollection.text().slice(0, 1);

			var letterCollectionList = '<div class="alphabet-section"><div class="letter-header">' + headingLetter + ' /</div><ul>';

			letterLoop:
			for (var j = i; j <= collections.length; j++) {

				var secondCollection = collections.eq(j);

				if ( headingLetter === secondCollection.text().slice(0, 1)) {
					letterCollectionList += '<li><a href="' + secondCollection.attr('href') + '">' + secondCollection.text() + '</a></li>';
				} else {
					i = j - 1;
					break letterLoop;
				}
			}

			$('#collection-list').append(letterCollectionList).removeClass('init-list');
		}
	}
});
